module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr4-be00294d34ec28a6e4fe148fb013791f.jpg";